export const sortItemsByLevelCodes = (itemA, itemB) => {
  const codeA = itemA.level_one_code + itemA.level_two_code;
  const codeB = itemB.level_one_code + itemB.level_two_code;
  return codeA - codeB;
};
